/** Диагональная штриховка стен из блоков. */
import { LineHatch, type WallHatchProps } from "./WallHatchGeometry";

export const BlockHatch = ({ outline }: WallHatchProps) => (
	<LineHatch outline={outline} angle={45} spacing={7} />
);
